const varribles = {
    apiUrl: 'https://www.api.teslaomsk.com/api'
    // apiUrl: 'https://www.api.1231709-cm19155.tw1.ru/api'
    // apiUrl: 'http://www.localhost:3000/api'
}

export { varribles }
